import {
  LOAD_SUCCESS_EVENEMENTS,
  LOAD_FAIL_EVENEMENTS,
  SAVE_SUCCESS_EVENEMENTS,
  SAVE_FAIL_EVENEMENTS,
  UPDATE_SUCCESS_EVENEMENTS,
  UPDATE_FAIL_EVENEMENTS,
  DELETE_SUCCESS_EVENEMENTS,
  DELETE_FAIL_EVENEMENTS,
} from "../actions/evenementAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_EVENEMENTS:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_EVENEMENTS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_EVENEMENTS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_EVENEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_EVENEMENTS:
      let updatedListe = [];
      state.data.forEach((item) => {
        if (item.evenement_id === action.payload.evenement_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_EVENEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_EVENEMENTS:
      const filtered = state.data.filter((item) => item.evenement_id !== action.id);
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_EVENEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
